import styled from 'styled-components';

export const Wrapper = styled.div`
    height: auto;
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
`;

export const Item = styled.div`
    box-sizing: border-box;

    &:first-of-type {
        padding-bottom: 18px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    &:last-of-type {
        padding-top: 18px;
    }
`;

export const InnerItem = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        flex-direction: row;
    }
`;

export const RadioButtonLabel = styled.label`
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    border-radius: 50%;

    width: 20px;
    height: 20px;

    border: 1.5px solid rgba(255, 255, 255, 0.3);
    border-radius: 100px;
    transition: background 0.2s ease;
`;

export const RadioButton = styled.input`
    opacity: 0;
    z-index: 1;
    cursor: pointer;
    width: 100%;
    position: absolute;
    height: 100%;

    &:hover ~ ${RadioButtonLabel} {
        background: rgba(255, 255, 255, 0.1);
    }

    &:checked + ${RadioButtonLabel} {
        border: 1.5px solid #523df1;
        background: transparent;
        &::after {
            content: '';
            width: 10px;
            height: 10px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #523df1;
            border-radius: 50%;
        }
    }
`;

export const RadioButtonHeading = styled.div`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 100%;
    margin: 4px 0;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;

    svg {
        margin-right: 4px;
    }

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        width: 120px;
        font-size: 18px;
    }
`;

export const RadioButtonDesc = styled.p`
    margin: 0;
    padding: 0 40px 0 0;
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: -0.03em;
    color: rgba(255, 255, 255, 0.5);

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        width: 75%;
    }
`;
